import React from "react";
import img1 from "../../assets/OnboardingImages/14.png";
import img2 from "../../assets/OnboardingImages/15.png";
import img3 from "../../assets/OnboardingImages/16.png";
import img4 from "../../assets/OnboardingImages/17.png";
import img5 from "../../assets/OnboardingImages/18.png";
import img6 from "../../assets/OnboardingImages/19.png";

const LeadMangement = () => {
  return (
    <div className="h-full bg-[#f3f4f6] pr-48">
      <div className="cursor-default">
        {/* Lead Management Section */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">Lead Management</h2>
        <p className="mt-3 text-lg">
          This feature helps you keep track of all the leads you upload via{" "}
          <strong>CSV or syncing CRM</strong>. Here you get two types of views:{" "}
          <strong>Account and Lead</strong>.
        </p>
        <p className="mt-3 text-lg">
          Account view will give you the company name, website, and other
          details.Whereas, Lead view gives you target personas details such as
          contact number, email address, and more.
        </p>
        <img
          className="mt-6 mb-16 border-solid border-2 border-black"
          src={img1}
        />
        <p className="mt-3 text-lg">
          Similarly, you will also get the lead view here where you can find the
          name, email, mobile number, and all the other details you import.
        </p>
        <img className='mt-6 mb-16 border-solid border-2 border-black' src={img2}/>
        <p className="mt-3 text-lg">
          <strong>How to import the Accounts or Leads?</strong>
        </p>
        <p className="mt-3 text-lg">
          Click on the <strong>Import</strong> button at the top right.
          
        </p>
        <img className='mt-6 mb-16 border-solid border-2 border-black' src={img3}/>
        <p className="mt-3 text-lg">         
           Here you can either <strong>Upload the CSV</strong> or{" "}
          <strong>drag and drop</strong>.
        </p>
      <img className='mt-6 mb-16 border-solid border-2 border-black' src={img4}/>
        <p className="mt-3 text-lg">
          Once you upload the file, you have to map all the sections you want to
          import into Zoi. Click on the <strong>Save Changes</strong> button,
          and you will be notified once the uploading is complete.
        </p>
        <img className='mt-6 mb-16 border-solid border-2 border-black' src={img5}/>

        <p className="mt-3 text-lg">
          Zoi also allows you to add a contact manually. Just click on the <strong>New Contact</strong> button. 
        </p>
        <img className='mt-6 mb-16 border-solid border-2 border-black' src={img3}/>
        <p className="mt-3 text-lg">
        Enter all the required fields. Click on the <strong>Submit</strong> button, and it's done!
        </p>
        <img className='mt-6 mb-16 border-solid border-2 border-black' src={img6}/>
          
      </div>
    </div>
  );
};

export default LeadMangement;
